import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "@/app/rootReducer";

/**
 * This "home" component automatically redirects based on roles:
 * - Admin => /admin/email-notifications
 * - Otherwise => /my-chapter
 */
function Home() {
  const navigate = useNavigate();
  const { userAppSettings } = useSelector(
    (state: RootState) => state.userAppSettings,
  );

  const roles = userAppSettings?.roles || [];

  useEffect(() => {
    if (roles.length > 0) {
      if (roles.includes("ROLE_ADMIN")) {
        navigate("/admin/email-notifications");
      } else {
        navigate("/my-chapter");
      }
    }
  }, [roles, navigate]);

  // Nothing is rendered because we immediately redirect
  return null;
}

export default Home;
